/**
 * Vuely Global Components
 */
// section tooltip
import Header from './components/Header/Index.vue'
import Footer from './components/Footer/Index.vue'
import Breadcrumbs from './components/Breadcrumbs/Index.vue'
import Images from './components/UI/Images.vue'
import AlertBox from './components/Alert/Index.vue'
import ConfirmBox from './components/Confirm/Index.vue'
import Designation from './modules/Designation/Index.vue'
import InventoryCategory from './modules/InventoryCategory/Index.vue'
import AccountHeads from './modules/AccountHeads/Index.vue'
import UserProfile from './modules/UserProfile/Index.vue'
import ReportHead from './components/ReportHead/Index.vue'
import RenewApp from './modules/RenewApp/Index.vue'
import SearchBox from './components/SearchBox/Index.vue'
import PaymentMode from './modules/PaymentMode/Index.vue'
import EventType from './modules/EventType/Index.vue'
import FlipCountdown from 'vue2-flip-countdown'
import Countdown from 'vuejs-countdown'


const GlobalComponents = {
   install(Vue) {
      Vue.component('Header', Header);
      Vue.component('Footer', Footer);
      Vue.component('Breadcrumbs', Breadcrumbs);
      Vue.component('Images', Images);
      Vue.component('AlertBox', AlertBox)
      Vue.component('ConfirmBox', ConfirmBox)
      Vue.component('Designation', Designation)
      Vue.component('InventoryCategory', InventoryCategory)
      Vue.component('AccountHeads', AccountHeads)
      Vue.component('ReportHead', ReportHead)
      Vue.component('UserProfile', UserProfile)
      Vue.component('RenewApp', RenewApp)
      Vue.component('SearchBox', SearchBox)
      Vue.component('PaymentMode', PaymentMode)
      Vue.component('EventType', EventType)
      Vue.component('FlipCountdown', FlipCountdown)
      Vue.component('Countdown', Countdown)
   }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js